import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

// COIPLAY_PRODUCT_APLUS_ASSET_RENDER_20260614_START
(function coiplayProductAplusAssetRender() {
  const marker = 'COIPLAY_PRODUCT_APLUS_RENDER_20260614';
  const needles = ['_catalog_aplus_20260614', '_series_aplus_20260614', '_lifestyle_20260614'];

  function isProductPage() {
    return /^\/(?:fr\/|es\/)?products\//.test(window.location.pathname);
  }

  function matches(src) {
    return needles.some((needle) => src && src.includes(needle));
  }

  function normalized(src) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.delete('width');
      return url.toString();
    } catch (error) {
      return src.split('&width=')[0].split('?width=')[0];
    }
  }

  function collectImages() {
    const seen = new Set();
    const images = [];
    document.querySelectorAll('img[src], img[srcset]').forEach((img) => {
      const candidates = [img.getAttribute('src') || ''];
      (img.getAttribute('srcset') || '').split(',').forEach((item) => {
        candidates.push((item.trim().split(/\s+/)[0]) || '');
      });
      candidates.forEach((src) => {
        if (!matches(src)) return;
        const clean = normalized(src);
        if (!clean || seen.has(clean)) return;
        seen.add(clean);
        images.push({ src: clean, alt: img.getAttribute('alt') || '' });
      });
    });
    return images;
  }

  function findAnchor() {
    const nodes = Array.from(document.querySelectorAll('rte-formatter'));
    return nodes.find((node) => {
      const text = (node.textContent || '').trim();
      return text.includes('COI Play California brand') ||
        text.includes("What's included") ||
        text.includes('Includes');
    });
  }

  function render() {
    if (!isProductPage()) return;
    if (document.querySelector('[data-coiplay-product-aplus]')) return;
    const anchor = findAnchor();
    const images = collectImages();
    if (!anchor || !anchor.parentNode || !images.length) return;
    const section = document.createElement('section');
    section.setAttribute('data-coiplay-product-aplus', marker);
    section.style.margin = '32px auto 0';
    section.style.maxWidth = '980px';
    section.style.width = '100%';
    images.forEach((image) => {
      const el = document.createElement('img');
      el.src = `${image.src}${image.src.includes('?') ? '&' : '?'}width=1600`;
      el.alt = image.alt;
      el.loading = 'lazy';
      el.style.display = 'block';
      el.style.width = '100%';
      el.style.height = 'auto';
      el.style.margin = '0 auto 24px';
      section.appendChild(el);
    });
    anchor.parentNode.insertBefore(section, anchor.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      render();
      window.setTimeout(render, 800);
    });
  } else {
    render();
    window.setTimeout(render, 800);
  }
})();
// COIPLAY_PRODUCT_APLUS_ASSET_RENDER_20260614_END
// COIPLAY_COI0023_AIRDROP_APLUS_20260614_START
(function coiplayCoi0023AirdropAplus() {
  const marker = 'COIPLAY_COI0023_AIRDROP_APLUS_20260614';
  const modules = [{"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_01_678.jpg?v=1781465493", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_01_686.jpg?v=1781465494", "alt": "COI Play Meow & Bark A+ module 1"}, {"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_02_679.jpg?v=1781465495", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_02_687.jpg?v=1781465496", "alt": "COI Play Meow & Bark A+ module 2"}, {"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_03_680.jpg?v=1781465497", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_03_688.jpg?v=1781465498", "alt": "COI Play Meow & Bark A+ module 3"}, {"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_04_681.jpg?v=1781465499", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_04_690.jpg?v=1781465500", "alt": "COI Play Meow & Bark A+ module 4"}, {"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_05_682.jpg?v=1781465501", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_05_691.jpg?v=1781465502", "alt": "COI Play Meow & Bark A+ module 5"}, {"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_06_683.jpg?v=1781465503", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_06_692.jpg?v=1781465504", "alt": "COI Play Meow & Bark A+ module 6"}, {"desktop": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_desktop_07_684.jpg?v=1781465505", "mobile": "https://cdn.shopify.com/s/files/1/0722/6094/4059/t/5/assets/coi0023_aplus_mobile_07_693.jpg?v=1781465507", "alt": "COI Play Meow & Bark A+ module 7"}];

  function isTargetProduct() {
    return /^\/(?:fr\/|es\/)?products\/meow-bark-bookmark-craft-kit\/?$/.test(window.location.pathname);
  }

  function findAnchor() {
    const nodes = Array.from(document.querySelectorAll('rte-formatter'));
    return nodes.find((node) => {
      const text = (node.textContent || '').trim();
      return text.includes('COI Play California brand') ||
        text.includes("What's included") ||
        text.includes('Includes');
    });
  }

  function render() {
    if (!isTargetProduct()) return;
    const anchor = findAnchor();
    if (!anchor || !anchor.parentNode) return;
    document.querySelectorAll('[data-coiplay-product-aplus]').forEach((node) => node.remove());
    const section = document.createElement('section');
    section.setAttribute('data-coiplay-product-aplus', marker);
    section.style.margin = '32px auto 0';
    section.style.maxWidth = '980px';
    section.style.width = '100%';
    modules.forEach((module) => {
      const picture = document.createElement('picture');
      picture.style.display = 'block';
      picture.style.margin = '0 auto 24px';
      const source = document.createElement('source');
      source.media = '(max-width: 749px)';
      source.srcset = module.mobile;
      const img = document.createElement('img');
      img.src = module.desktop;
      img.alt = module.alt;
      img.loading = 'lazy';
      img.style.display = 'block';
      img.style.width = '100%';
      img.style.height = 'auto';
      picture.appendChild(source);
      picture.appendChild(img);
      section.appendChild(picture);
    });
    anchor.parentNode.insertBefore(section, anchor.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      render();
      window.setTimeout(render, 900);
      window.setTimeout(render, 2200);
    });
  } else {
    render();
    window.setTimeout(render, 900);
    window.setTimeout(render, 2200);
  }
})();
// COIPLAY_COI0023_AIRDROP_APLUS_20260614_END
